import React, { useState } from "react";
import blogPosts from "../../data/blogPosts";

const BlogCard = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [modalPost, setModalPost] = useState(null);

  const categories = ["All", ...new Set(blogPosts.map(post => post.category))];

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory =
      selectedCategory === "All" || post.category === selectedCategory;
    const matchesSearch = post.title
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div style={{ padding: "40px 20px", maxWidth: "1200px", margin: "auto" }}>
      <h1 style={{
        textAlign: "center",
        fontSize: "36px",
        fontWeight: "bold",
        marginBottom: "30px",
        fontFamily: `'Segoe UI', sans-serif`
      }}>
        Explore Our Blog
      </h1>

      {/* Search & Categories */}
      <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginBottom: "30px" }}>
        <input
          type="text"
          placeholder="Search by title..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            padding: "10px 15px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            maxWidth: "400px",
            margin: "auto"
          }}
        />

        <div style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "10px",
          marginTop: "10px"
        }}>
          {categories.map((cat, idx) => (
            <button
              key={idx}
              onClick={() => setSelectedCategory(cat)}
              style={{
                padding: "8px 16px",
                borderRadius: "20px",
                border: "1px solid #0d6efd",
                backgroundColor: selectedCategory === cat ? "#0d6efd" : "white",
                color: selectedCategory === cat ? "white" : "#0d6efd",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.3s ease"
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Blog Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "30px"
        }}
      >
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                cursor: "pointer"
              }}
              onClick={() => setModalPost(post)}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.08)";
              }}
            >
              <img
                src={post.image}
                alt={post.title}
                style={{
                  width: "100%",
                  height: "180px",
                  objectFit: "cover",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
              />
              <div style={{ padding: "20px" }}>
                <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "10px", color: "#0d6efd" }}>
                  {post.title}
                </h2>
                <p style={{ fontSize: "14px", color: "#555", marginBottom: "15px", lineHeight: "1.5" }}>
                  {post.summary}
                </p>
                <div style={{ fontSize: "13px", color: "#888" }}>
                  By <strong>{post.author}</strong> | {post.date}
                </div>
                <div style={{
                  marginTop: "10px",
                  fontSize: "12px",
                  backgroundColor: "#f0f0f0",
                  padding: "5px 10px",
                  borderRadius: "20px",
                  display: "inline-block",
                  color: "#333"
                }}>
                  {post.category}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div style={{ textAlign: "center", gridColumn: "1 / -1" }}>
            No posts found.
          </div>
        )}
      </div>

      {/* Modern Modal */}
      {modalPost && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          backdropFilter: "blur(4px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
          animation: "fadeIn 0.3s"
        }}
          onClick={() => setModalPost(null)}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
              maxWidth: "800px",
              width: "90%",
              maxHeight: "90%",
              overflowY: "auto",
              padding: "25px",
              position: "relative",
              transform: "scale(0.8)",
              animation: "scaleIn 0.3s forwards",
              boxShadow: "0 12px 40px rgba(0,0,0,0.25)"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={modalPost.image}
              alt={modalPost.title}
              style={{
                width: "100%",
                borderRadius: "12px",
                marginBottom: "20px",
                transition: "transform 0.3s ease"
              }}
              onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
              onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
            />
            <h2 style={{ color: "#0d6efd", marginBottom: "10px" }}>{modalPost.title}</h2>
            <div style={{ fontSize: "14px", color: "#555", marginBottom: "15px" }}>
              By <strong>{modalPost.author}</strong> | {modalPost.date} | Category: {modalPost.category}
            </div>
            <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
              {modalPost.summary} <br />
              {/* You can add full blog content here */}
            </p>
            <button
              onClick={() => setModalPost(null)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "#0d6efd",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "16px"
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* Inline animations */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes scaleIn {
            from { transform: scale(0.8); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default BlogCard;